import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// package.json
var name = "@vercel/speed-insights";
var version = "1.0.9"; // src/queue.ts

var initQueue = function initQueue() {
  if (window.si) return;

  window.si = function a() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    (window.siq = window.siq || []).push(params);
  };
}; // src/utils.ts


function isBrowser() {
  return typeof window !== "undefined";
}

function detectEnvironment() {
  try {
    var env = process.env.NODE_ENV;

    if (env === "development" || env === "test") {
      return "development";
    }
  } catch (e) {}

  return "production";
}

function isDevelopment() {
  return detectEnvironment() === "development";
}

function computeRoute(pathname, pathParams) {
  if (!pathname || !pathParams) {
    return pathname;
  }

  var result = pathname;

  try {
    for (var _i = 0, _Object$entries = Object.entries(pathParams); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          valueOrArray = _Object$entries$_i[1];

      var isValueArray = Array.isArray(valueOrArray);
      var value = isValueArray ? valueOrArray.join("/") : valueOrArray;
      var expr = isValueArray ? "...".concat(key) : key;
      var matcher = new RegExp("/".concat(escapeRegExp(value), "(?=[/?#]|$)"));

      if (matcher.test(result)) {
        result = result.replace(matcher, "/[".concat(expr, "]"));
      }
    }

    return result;
  } catch (e) {
    return pathname;
  }
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
} // src/generic.ts


var SCRIPT_URL = "https://va.vercel-scripts.com/v1/speed-insights";
var PROD_SCRIPT_URL = "".concat(SCRIPT_URL, "/script.js");
var DEV_SCRIPT_URL = "".concat(SCRIPT_URL, "/script.debug.js");
var PROXY_SCRIPT_URL = "/_vercel/speed-insights/script.js";

function injectSpeedInsights() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a;

  if (!isBrowser() || props.route === null) return null;
  initQueue();
  var isSelfHosted = Boolean(props.dsn);
  var productionScript = isSelfHosted ? PROD_SCRIPT_URL : PROXY_SCRIPT_URL;
  var src = props.scriptSrc || (isDevelopment() ? DEV_SCRIPT_URL : productionScript);
  if (document.head.querySelector("script[src*=\"".concat(src, "\"]"))) return null;

  if (props.beforeSend) {
    (_a = window.si) == null ? void 0 : _a.call(window, "beforeSend", props.beforeSend);
  }

  var script = document.createElement("script");
  script.src = src;
  script.defer = true;
  script.dataset.sdkn = name + (props.framework ? "/".concat(props.framework) : "");
  script.dataset.sdkv = version;

  if (props.sampleRate) {
    script.dataset.sampleRate = props.sampleRate.toString();
  }

  if (props.route) {
    script.dataset.route = props.route;
  }

  if (props.endpoint) {
    script.dataset.endpoint = props.endpoint;
  }

  if (props.dsn) {
    script.dataset.dsn = props.dsn;
  }

  if (isDevelopment() && props.debug === false) {
    script.dataset.debug = "false";
  }

  script.onerror = function () {
    console.log("[Vercel Speed Insights] Failed to load script from ".concat(src, ". Please check if any content blockers are enabled and try again."));
  };

  document.head.appendChild(script);
  return {
    setRoute: function setRoute(route) {
      script.dataset.route = route !== null && route !== void 0 ? route : void 0;
    }
  };
}

var generic_default = {
  injectSpeedInsights: injectSpeedInsights,
  computeRoute: computeRoute
};
export { computeRoute, generic_default as default, injectSpeedInsights };